@use './variables' as *;

:host {
  display: $divider-host-display;
}

@mixin divider() {
  display: $divider-display;
  width: $divider-width;
  height: $divider-height;
  margin: $divider-margin;
  box-shadow: $divider-box-shadow;
}

.divider-grey {
  @include divider();
  background-color: $divider-grey-background-color;
}

.divider-dark {
  @include divider();
  background-color: $divider-dark-background-color;
}
